import React from "react";

const ViewStopBang = ({ data, ismodalopen, setHtmlModal }) => {
  if (!ismodalopen || !data || !data.json_data) return null;

  const json = data.json_data;

  const closeModal = () => setHtmlModal(false);

  const stopQuestions = [
    { q: "Do you SNORE loudly (louder than talking or loud enough to be heard through closed doors)?", key: "qanswer_1_1" },
    { q: "Do you often feel TIRED, fatigue, or sleepy during daytime?", key: "qanswer_1_2" },
    { q: "Has anyone OBSERVED you stop breathing during your sleep?", key: "qanswer_1_3" },
    { q: "Do you have or are you being treated for high blood PRESSURE?", key: "qanswer_1_4" },
  ];

  const bangQuestions = [
    { q: "BMI more than 35kg/m2?", key: "qanswer_1_5" },
    { q: "AGE over 50 years old?", key: "qanswer_1_6" },
    { q: "NECK circumference > 16 inches (40cm)?", key: "qanswer_1_7" },
    { q: "GENDER: Male?", key: "qanswer_1_8" },
  ];
const renderYesNo = (value) => (
  <div className="flex space-x-4 mt-2">
    {["YES", "NO"].map((opt) => (
      <span
        key={opt}
        className={`px-4 py-2 rounded-full text-sm font-sans border ${
          json[value]?.toUpperCase() === opt
            ? "bg-blue-600 text-white border-blue-600"
            : "bg-white border-gray-300 text-black"
        }`}
      >
        {opt}
      </span>
    ))}
  </div>
);

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white p-6 rounded-lg shadow-lg max-w-4xl w-full max-h-[90vh] overflow-y-auto text-start">
        {/* Header */}
        <div className="flex justify-between items-center mb-4">
          <h2 className="text-2xl font-bold">{json.form_name}</h2>
          <button onClick={closeModal} className="text-gray-500 hover:text-gray-700">&times;</button>
        </div>

        {/* Reference / Instructions */}
        <div className="mb-4">
          <p className="text-gray-700">
            Chung F et al Anesthesiology 2008 and BJA 2012
          </p>
        </div>

        {/* STOP Section */}
        <h3 className="font-bold text-xl mt-4 mb-2">STOP</h3>
        {stopQuestions.map((q, idx) => (
          <div key={idx} className="mb-4">
            <label className="font-bold text-base">{q.q}</label>
            {renderYesNo(q.key)}
          </div>
        ))}

        {/* BANG Section */}
        <h3 className="font-bold text-xl mt-4 mb-2">BANG</h3>
        {bangQuestions.map((q, idx) => (
          <div key={idx} className="mb-4">
            <label className="font-bold text-base">{q.q}</label>
            {renderYesNo(q.key)}
          </div>
        ))}

        {/* Total Score */}
        <div className="mt-6 p-4 bg-gray-100 border-l-4 border-blue-600 rounded-md text-gray-800">
          <p className="font-semibold">Total Score: {json.total_score}</p>
          <p className="mt-2">
            High risk of OSA: 5-8 <br />
            Intermediate risk of OSA: 3-4 <br />
            Low risk of OSA: 0-2
          </p>
        </div>
      </div>
    </div>
  );
};

export default ViewStopBang;
